// Port of api/fuel/app/classes/filter/search/games/sorts/query/collection/group/status.php
import F from 'offline/filter/constants'
import { sorted, sortReverse, sortPriority } from 'offline/filter/core/search/unit'

var STATUS_SORTS = {
	'status.prevowned': 'collection_prevowned',
	'status.fortrade': 'collection_fortrade',
	'status.want': 'collection_want',
	'status.wanttoplay': 'collection_wanttoplay',
	'status.wanttobuy': 'collection_wanttobuy',
	'status.wishlist': 'collection_wishlist',
	'status.preordered': 'collection_preordered',
	'status.hasparts': 'collection_hasparts',
	'status.wantparts': 'collection_wantparts'
}

function getActiveName(filter) {
	var keys = Object.keys(STATUS_SORTS)
	for (var i = 0; i < keys.length; i++) {
		if (sorted(keys[i], filter) > 0) return keys[i]
	}
	return null
}

export default {
	name: 'status.*',
	post: false,
	require: function(config, filter) {
		return config.ownerType !== F.OWNER_USER && getActiveName(filter) !== null
	},
	run: function(config, filter, data, query) {
		var name = getActiveName(filter)
		var field = STATUS_SORTS[name]
		query.where('cs.' + field, '=', 1)
		query.order('COUNT(DISTINCT(cs.user_id))', sortReverse(name, filter), sortPriority(name, filter))
	}
}
